__turbopack_context__.v({
  "helios-university-badge": "_31aZ-a_helios-university-badge",
  "helios-university-badge--compact": "_31aZ-a_helios-university-badge--compact",
});
